import { schema } from 'normalizr'
const shopRestaurant = new schema.Entity('shopRestaurants', {})
export default shopRestaurant
